export default "__VITE_ASSET__thwpVkkJ__"